<template>
    <div class="container">
        <app-banner role="banner"/>

        <transition mode="out-in" name="fade">
            <div class="transition-root" key="loading" v-if="loading">
                <div class="row">
                    <loading-indicator>Henter temaer..</loading-indicator>
                </div>
            </div>
            <div class="transition-root" key="notLoading" v-else>
                <div class="row">
                    <content-card
                            class="col-sm"
                            v-bind:key="i"
                            v-bind:media="card.picture"
                            v-bind:title="card.title"
                            v-for="(card, i) in themeCards"
                            v-on:onClick="onSelectTheme(card)"
                    />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import ContentCard from '@/components/content-card'
    import LoadingIndicator from '@/components/loading-indicator'
    import AppBanner from '@/components/app-banner'
    import * as MutationTypes from '@/store/mutation-types'
    import AppConfig from '@/app-config'
    import {getSinglePlayerUrl} from '@/utils/UrlUtil'
    import GameType from "@/enum/GameType";
    import GamePhase from "@/enum/GamePhase";
    import PlayerType from '@/enum/PlayerType'

    export default {
        components: {
            ContentCard,
            LoadingIndicator,
            AppBanner
        },
        data() {
            /**
             * {
            id: 1,
            title: "My title",
            picture: "@img/expressions/expression-happy.png"
          }
             */
            return {
                loading: true,
                themeCards: []
            }
        },
        mounted() {
            if (!this.$apiClient.hasBaseUrlBeenSet()) {
                console.log('$apiClient had no base URL - going back to index')

                // The game is not at the right point right now.. let's revert the user to the connect screen
                this.$router.push(getSinglePlayerUrl('index'))

                return
            }

            this.$gameClient.sendLocal({
                playerType: PlayerType.SinglePlayer,
                _phase: GamePhase.SelectTheme,
                _currentPageIndex: 0,
                _selectedCaseId: null,
                _selectedThemeId: null
            });

            this.$store.commit(MutationTypes.SET_CURRENT_THEME, null)

            this.$apiClient.getThemes(GameType.SinglePlayer, (themes) => {
                this.themeCards = themes
                this.loading = false

                if (AppConfig.autoThemeSelection) {
                    for (let theme of themes) {
                        if (theme.id === AppConfig.autoThemeSelection) {
                            this.onSelectTheme(theme)
                        }
                    }
                }
            })
        },
        methods: {
            onSelectTheme(theme) {
                let themeId = theme.id

                this.$store.commit(MutationTypes.SET_CURRENT_THEME, theme)

                this.$router.push(getSinglePlayerUrl('select-case'))
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
</style>
